import { Controller } from "@hotwired/stimulus"

// Mostra/amaga els camps del formulari de productor segons el tipus de persona
// seleccionat. És només millora d'UX: el servidor normalitza i valida igualment
// segons person_type encara que el JS no s'executi.
export default class extends Controller {
  static targets = ["fisicaFields", "juridicaFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.element.querySelector("input[name*='person_type']:checked")
    const fisica = selected?.value === "fisica"

    this.fisicaFieldsTargets.forEach((el) => { el.hidden = !fisica })
    this.juridicaFieldsTargets.forEach((el) => { el.hidden = fisica })
  }
}
